import axios from 'axios'

export interface WaveformStem {
  name: string
  min: number[]
  max: number[]
  timepoints: number[]
  duration: number
}

interface WaveformData {
  main: WaveformStem | null
  stems: WaveformStem[]
}

type RawStem = {
  min?: number[]
  max?: number[]
  time_points?: number[]
  duration?: number
}

const toStem = (name: string, raw: RawStem): WaveformStem | null => {
  if (!Array.isArray(raw.min) || !Array.isArray(raw.max)) return null
  return {
    name,
    min: raw.min,
    max: raw.max,
    timepoints: raw.time_points ?? [],
    duration: raw.duration ?? 0,
  }
}

const parseWaveformData = (data: unknown): WaveformData => {
  const empty: WaveformData = { main: null, stems: [] }
  if (!data || typeof data !== 'object') return empty
  const root = data as Record<string, unknown>
  if (root.format_version !== 2) return empty

  const main = toStem('main', (root.main ?? {}) as RawStem)

  const stems: WaveformStem[] = []
  const stemsRaw = root.stems
  if (stemsRaw && typeof stemsRaw === 'object') {
    for (const [name, value] of Object.entries(stemsRaw)) {
      const stem = toStem(name, (value ?? {}) as RawStem)
      if (stem) stems.push(stem)
    }
  }

  return { main, stems }
}

const waveformCache = new Map<string, Promise<WaveformData>>()

export const fetchWaveformData = (url: string): Promise<WaveformData> => {
  let cached = waveformCache.get(url)
  if (!cached) {
    cached = axios.get(url).then((result) => parseWaveformData(result.data))
    cached.catch(() => waveformCache.delete(url))
    waveformCache.set(url, cached)
  }
  return cached
}
